const drawerHeaderTokens = ({ colorsBrand, colors, borders, space }) => ({
  colors: {
    bg: colorsBrand[1],
    color: colors.white,
    arrow: colors.white,
  },
  borders: borders[0],
  space: {
    py: space[4],
    px: space[4],
  },
  sizes: {
    minHeight: 'auto',
  },
});

export default drawerHeaderTokens;
